module.exports = {"id":"179789","name":"Damien Da Silva","rating":"78","photo":"./data/images/photos/4/179789.png","club":{"name":"SM Caen","logo":"./data/images/clubs/SMCaen.png"},"positions":["DC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DamienDaSilva0.json
// module id = 906
// module chunks = 0